export default {
	// es-ES.js
	security: {
		securityBind: "Vinculación de seguridad",
		securitySettings: "Configuración de seguridad",
		level: "Medio",
		confirm: "Confirmar",
		submitting: "Enviando...",
		add: "Agregar",
		change: "Cambiar",
		success: "Actualizado correctamente",
		select: "Seleccionar",

		birthday: "Fecha de nacimiento",
		birthdayDesc: "Vincula una fecha de nacimiento de contacto para una comunicación más sencilla. Tu información personal permanecerá protegida.",
		month: "Mes",
		day: "Día",
		year: "Año",
		birthdayRequired: "La fecha de nacimiento es obligatoria.",
		invalidBirthday: "Fecha de nacimiento no válida.",
		invalidMonth: "Mes no válido.",
		invalidDay: "Día no válido.",
		invalidYear: "Año no válido.",
		updateBirthdayFail: "No se pudo actualizar la fecha de nacimiento",
		birthdayVerify: "Verificación de vinculación de cumpleaños",
		birthdayVerifyDesc: "Vincula tu fecha de nacimiento para mejorar la seguridad de tu cuenta.",

		email: "Correo electrónico de contacto",
		emailDesc: "Correo electrónico para la seguridad de la cuenta. Solo tú puedes vincularlo.",
		emailRequired: "El correo electrónico es obligatorio.",
		emailInvalid: "Dirección de correo incorrecta.",
		updateEmailFail: "No se pudo actualizar el correo electrónico",
		emailVerify: "Verificación de vinculación de correo electrónico",
		emailVerifyDesc: "Verifica tu correo electrónico para mejorar la seguridad de tu cuenta.",

		phone: "Número de teléfono",
		bindPhone: "Vincular número de teléfono",
		phoneDesc: "Número de teléfono para la seguridad de la cuenta. Solo tú puedes vincularlo.",
		phoneRequired: "El número de teléfono es obligatorio.",
		phoneUsed: "Usa un número de teléfono diferente.",
		updatePhoneFail: "No se pudo actualizar el número de teléfono",
		noCode: "¿No recibiste el código?",
		smsHelp: "Si lo has intentado varias veces y aún no has recibido el código de verificación.",
		smsTips1: "1. Verifica si el número de móvil que ingresaste es correcto.",
		smsTips2: "2. Verifica si tu número de móvil está desactualizado.",
		smsTips3: "3. Verifica si el mensaje está en la bandeja de SMS.",
		smsTips4: "4. El mensaje puede retrasarse unos minutos.",
		phoneVerify: "Verificación de vinculación de número de teléfono",
		phoneVerifyDesc: "Verifica tu número de teléfono para mejorar la seguridad de tu cuenta.",

		setPassword: "Establecer contraseña",
		passwordDesc: "Establece tu contraseña de inicio de sesión.",
		clickSelectBirthday: "Clic para seleccionar fecha",
		selectBirthday: "Seleccionar fecha",
		confirm: "Confirmar",
		cancel: "Cancelar",

		withdrawPassword: "Contraseña de Retiro",
		withdrawpasswordDesc: "Configura tu contraseña para retiros de fondos.",
		set: "Configurar",
	},

	contactPhone: {
		title: "Cambiar Número de Teléfono",
		titleMobile: "Cambiar",
		description: "Añade un número de teléfono de contacto para una comunicación más fácil. Tu información personal permanecerá protegida.",
		label: "Número de Teléfono de Contacto",
		confirm: "Confirmar",
		submitting: "Enviando...",
		required: "El número de teléfono es obligatorio",
		invalid: "Número de teléfono inválido",
		success: "¡Número de teléfono actualizado con éxito!",
		updateFailed: "Error al actualizar",
		tryAgain: "Error al actualizar, por favor inténtalo de nuevo más tarde",
		verifyTitleMobile: "Verificación de Teléfono",
		titleMobile: "Vincular Teléfono",
		changeTitleMobile: "Cambiar Teléfono",
		securityTip: "Teléfono para seguridad de la cuenta. Solo tú puedes vincularlo.",
		placeholder: "Número de Teléfono",
		noCodeReceived: "¿No has recibido el código?",
		codeDescription: "Introduce el código de verificación de 6 dígitos enviado a tus datos de contacto a continuación:",
		resendIn: "Reenviar en {countdown} s",
		resend: "Reenviar",
		submitting: "Enviando...",
		confirm: "Confirmar",
		invalidCode: "Por favor, introduce un código válido de 6 dígitos",
		required: "El número de teléfono es obligatorio",
		invalid: "Por favor, introduce un número de teléfono válido",
		success: "Actualizado correctamente",
		updateFailed: "Error en la actualización",
		tryAgain: "Por favor, inténtelo de nuevo más tarde"
	},

	contactEmail: {
		title: "Cambiar Email",
		titleMobile: "Cambiar",
		description: "Añade un correo electrónico de contacto para una comunicación más fácil. Tu información personal permanecerá protegida.",
		label: "Correo Electrónico de Contacto",
		placeholder: "Correo Electrónico",
		confirm: "Confirmar",
		submitting: "Enviando...",
		required: "El email no puede estar vacío",
		invalid: "Por favor introduce una dirección de email válida",
		success: "¡Email actualizado con éxito!",
		updateFailed: "Error al actualizar",
		tryAgain: "Error al actualizar, por favor inténtalo de nuevo más tarde",
		verifyTitleMobile: "Verificación de Email",
		titleMobile: "Vincular Email",
		changeTitleMobile: "Cambiar Email",
		securityTip: "Email para seguridad de la cuenta. Solo tú puedes vincularlo.",
		noCodeReceived: "¿No has recibido el código?",
		codeDescription: "Introduce el código de verificación de 6 dígitos enviado a tus datos de contacto a continuación:",
		resendIn: "Reenviar en {countdown} s",
		resend: "Reenviar",
		submitting: "Enviando...",
		confirm: "Confirmar",
		invalidCode: "Por favor, introduce un código válido de 6 dígitos",
		required: "El email es obligatorio",
		invalid: "Por favor, introduce una dirección de email válida",
		success: "Actualizado correctamente",
		updateFailed: "Error en la actualización",
		tryAgain: "Por favor, inténtelo de nuevo más tarde"
	},

	accountInfo: {
		profileInfo: "Información del Perfil",
		contactInfo: "Información de Contacto",
		privacy: "Privacidad",
		contactEmail: "Correo de Contacto",
		contactPhone: "Número de Teléfono de Contacto",
		addEmailDesc: "Añade un correo de contacto para una comunicación más fácil. Tu información personal permanecerá protegida.",
		addPhoneDesc: "Añade un número de teléfono de contacto para una comunicación más fácil. Tu información personal permanecerá protegida.",
		hideUsername: "Ocultar mi nombre de usuario de las listas públicas",
		add: "Añadir",
		change: "Cambiar",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "JUGADOR",
		copied: "¡Copiado!",
		hideSuccess: "Nombre de usuario ocultado con éxito",
		showSuccess: "Nombre de usuario mostrado con éxito",
		operationFailed: "Operación fallida",
		editProfile: "Editar Perfil",
		contactInfo: "Información de Contacto",
		contactEmail: "Correo Electrónico de Contacto",
		emailTip: "Añada un correo electrónico de contacto para facilitar la comunicación. Su información personal permanecerá protegida.",
		change: "Cambiar",
		addEmail: "Añadir Correo Electrónico",
		contactPhone: "Número de Teléfono de Contacto",
		phoneTip: "Añada su número de teléfono para una verificación segura de la cuenta.",
		addPhone: "Añadir Número de Teléfono",
		birthdayBind: "Verificación de vinculación de cumpleaños",
		birthdayTip: "Vincule su cumpleaños para mejorar la seguridad de su cuenta.",
		addBirthday: "Añadir Cumpleaños",
		personalInfo: "Información Personal",
		personalTip: "Verifique su identidad para desbloquear más servicios. Sus datos están seguros.",
		verifyNow: "Verificar Ahora",
		hideUsernameTip: "Cuando esté habilitado, otros usuarios no podrán ver su nombre de usuario en las listas públicas.",
	},

	kyc: {
		title: "Verificación de Identidad",
		verifyIdentity: "Verifica tu identidad",
		completeDesc: "Completa la verificación de identidad para mantener tu cuenta segura y desbloquear todas las funciones.",
		failed: "La verificación falló. Inténtalo de nuevo.",
		reVerify: "Verificar de nuevo",
		checkYouOut: "Vamos a verificar tu identidad",
		prepareDoc: "Prepara tu documento",
		prepareDocDesc: "Ten a mano un documento de identidad válido.",
		useSmartphone: "Usa un smartphone",
		useSmartphoneDesc: "Necesitarás un smartphone para completar la verificación.",
		scanQr: "Escanea el código QR",
		scanQrDesc: "Escanea el código QR con tu teléfono para continuar en el móvil.",
		noSmartphone: "¿No tienes smartphone?",
		completeOnMobile: "Completar en el móvil"
	},

	verify: {
		title: "Verificación",
		personalVerification: "Verificación Personal",
		weak: "Débil",
		level1: "Nivel 1",
		personalInfo: "Información Personal",
		personalInfoDesc: "Completa tu información personal para mejorar la seguridad de tu cuenta.",
		verifyNow: "Verificar Ahora",
		level2: "Nivel 2",
		kycVerification: "Verificación KYC",
		kycDesc: "Completa la verificación KYC para desbloquear límites más altos y acceso total.",
		docTip: "Asegúrate de que tus documentos sean claros y válidos antes de enviarlos."
	},

	personalInfo: {
		verify: "Verificación",
		completeInfo: "Completa tu información",
		completeInfoDesc: "Rellena tus datos personales para completar la verificación.",
		firstName: "Nombre",
		paternalSurname: "Apellido Paterno",
		maternalSurname: "Apellido Materno",
		contactNumber: "Número de Contacto",
		phoneUsed: "Este número de teléfono ya está en uso.",
		contactEmail: "Correo de Contacto",
		invalidEmail: "Dirección de correo inválida.",
		detailedAddress: "Dirección Detallada",
		city: "Ciudad",
		street: "Calle",
		neighborhood: "Barrio",
		houseNumber: "Número de Casa",
		postalCode: "Código Postal",
		save: "Guardar",
		male: "Masculino",
		female: "Femenino"
	},

	withdrawPassword: {
		changeTitle: "Cambiar Contraseña de Retiro",
		setTitle: "Establecer Contraseña de Retiro",
		changeDesc: "Introduce tu contraseña anterior y establece una nueva contraseña de retiro.",
		setDesc: "Establece una contraseña de retiro para proteger tus fondos.",
		oldPlaceholder: "Contraseña de Retiro Anterior",
		newPlaceholder: "Nueva Contraseña de Retiro",
		confirmPlaceholder: "Confirmar Contraseña de Retiro"
	},

	contactBirthday: {
		title: "Fecha de nacimiento de contacto",
		desc: "Vincula una fecha de nacimiento de contacto para una comunicación más sencilla. Tu información personal permanecerá protegida.",
		label: "Fecha de nacimiento de contacto",
		invalid: "Fecha de nacimiento no válida."
	},

	changePassword: {
		title: "Cambiar Contraseña",
		expiredDesc: "Tu contraseña ha caducado. Establece una nueva contraseña para continuar.",
		verifyOldDesc: "Introduce tu contraseña anterior y establece una nueva.",
		passwordPlaceholder: "Contraseña Anterior",
		newPlaceholder: "Nueva Contraseña",
		confirmPlaceholder: "Confirmar Nueva Contraseña",
		lengthError: "La contraseña debe tener entre 6 y 30 caracteres.",
		sameAsOld: "La nueva contraseña no puede ser igual a la anterior.",
		confirmRequired: "Confirma tu nueva contraseña.",
		notMatch: "Las contraseñas no coinciden.",
		success: "Contraseña cambiada correctamente",
		failed: "No se pudo cambiar la contraseña"
	},

	settingsNav: {
		title: "Ajustes",
		accountInfo: "Información de la Cuenta",
		security: "Seguridad"
	},


	verificationBirthday: {
		title: "Cumpleaños",
		securityTip: "Fecha de nacimiento para la seguridad de la cuenta. Solo tú puedes vincularla.",
		clickSelectBirthday: "Haz clic para seleccionar el cumpleaños",
		invalidBirthday: "Fecha de cumpleaños inválida",
		submitting: "Enviando...",
		confirm: "Confirmar",
		cancel: "Cancelar",
		selectBirthday: "Seleccionar Cumpleaños",
		birthdayRequired: "La fecha de nacimiento es obligatoria",
		updateBirthdayFail: "Error al actualizar el cumpleaños",
		success: "Actualizado con éxito"
	}
};